import { __decorate } from "tslib";
import { EventBus } from '@blade/common';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
let default_1 = class default_1 extends Vue {
    dataSeries;
    dataX;
    option;
    propRef;
    charts;
    onDataXChange(dataX) {
        // @ts-ignore
        this.option.xAxis.data = dataX || [];
    }
    onDataSeriesChange(dataSeries) {
        this.initDataSeries(dataSeries);
        this.draw();
    }
    initDataSeries(dataSeries) {
        const [data0] = dataSeries;
        if (data0 instanceof Array) {
            dataSeries.forEach((data, index) => {
                this.option.series[index].data = data || [];
            });
        }
        else if (typeof data0 === 'number' || typeof data0 === 'string') {
            this.option.series[0].data = dataSeries || [];
        }
    }
    mounted() {
        // @ts-ignore
        this.option.xAxis.data = this.dataX || [];
        // this.option.xAxis.axisLabel.interval = this.interval;
        // @ts-ignore
        this.initDataSeries(this.dataSeries);
        this.charts = echarts.init(this.$refs[this.propRef]);
        this.draw();
        EventBus.$on('sidebar', () => {
            setTimeout(() => {
                this.charts.resize();
            }, 300);
        });
    }
    draw() {
        if (!this.charts)
            return;
        this.charts.clear();
        this.charts.resize();
        //
        if (this.option?.tooltip) {
            this.option.tooltip.className =
                this.option.tooltip?.className ?? 'echarts-tooltip echarts-tooltip-dark';
        }
        this.charts.setOption(this.option, true);
    }
    onLocaleChange(newVal) {
        this.draw();
    }
    onResize() {
        this.charts && this.charts.resize();
    }
    beforeDestroy() {
        EventBus.$off('sidebar');
    }
};
__decorate([
    Prop({ default: [] })
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop({ default: [] })
], default_1.prototype, "dataX", void 0);
__decorate([
    Prop()
], default_1.prototype, "option", void 0);
__decorate([
    Prop()
], default_1.prototype, "propRef", void 0);
__decorate([
    Watch('dataX')
], default_1.prototype, "onDataXChange", null);
__decorate([
    Watch('dataSeries')
], default_1.prototype, "onDataSeriesChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({ name: 'lineEchartsContrain' })
], default_1);
export default default_1;
